import React from 'react'
import { useState } from 'react'

export default function Form() {
    let obj={
        title: "",
        describe: "",
        date: ""
    }
    const [user,setUser] = useState(obj);

    function handleChange(e){
        setUser({...user,[e.target.name]:e.target.value});
    }

    async function handleSubmit(event){
        event.preventDefault();
        console.log(user);

        fetch(`https://crud22.onrender.com/notes`,{
            method: 'POST',
            body: JSON.stringify(user),
            headers: { 'Content-Type': "application/json"}
            })
    }


  return (
    <div>
        <form action="" onSubmit={handleSubmit}>
            <input name="title" type="text" placeholder='title' onChange={handleChange} />
            <textarea name="describe"  placeholder='Enter Descriptions..'onChange={handleChange}></textarea>
            <input type="date" name='date' onChange={handleChange}/>
            <input type="submit" value="submit"/>
        </form>
    </div>
  )
}
